import { format, subDays } from 'date-fns';

export const DATE_FORMAT = {
  SHORT: 'MMM d, yyyy',
  LONG: 'MMMM d, yyyy',
  FULL: 'MMMM d, yyyy, hh:mm a',
  TIME_ONLY: 'hh:mm a',
};

export const formatDate = (dateString: string, date_format = DATE_FORMAT.FULL) => {
  const date = new Date(dateString);
  return format(date, date_format);
};

export const now = () => {
  return new Date().toISOString();
};

export const daysAgo = (days: number): string => {
  const date = new Date();

  return subDays(date, days).toISOString();
};

export const humanizeDuration = (seconds: number): string => {
  if (seconds < 60) {
    return `${seconds}s`;
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  if (hours > 0) {
    return `${hours}h ${Math.ceil(minutes)}m ${Math.ceil(remainingSeconds)}s`;
  }

  return `${minutes}m ${Math.ceil(remainingSeconds)}s`;
};

export function formatDuration(seconds: number | null): string {
  if (seconds === null || seconds === undefined) return '—';
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

export function formatTime(datetime: string | null): string {
  if (!datetime) return '—';
  try {
    return format(new Date(datetime), 'MMM d, yyyy h:mm a');
  } catch {
    return datetime;
  }
}

//create a function to calculate the difference between two dates
// return the difference in seconds
export function dateDifferenceInSeconds(date1: string, date2: string): number {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  const diffInMs = Math.abs(d1.getTime() - d2.getTime());
  return Math.floor(diffInMs / 1000);
}

export function humanizeDateDifference(date1: string, date2: string): string {
  const seconds = dateDifferenceInSeconds(date1, date2);

  if (seconds < 60) {
    return 'just now';
  }

  if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60);
    return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
  }

  if (seconds < 86400) {
    const hours = Math.floor(seconds / 3600);
    return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
  }

  if (seconds < 604800) {
    const days = Math.floor(seconds / 86400);
    return `${days} day${days !== 1 ? 's' : ''} ago`;
  }

  return formatTime(date1);
}
